import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

/**
 * Auswertung -- der modulübergreifende Reporting-Hub. Jede Fachdomäne bekommt hier eine eigene
 * Sektion. Bewusst OHNE eigenes Recht am Modul (requiredPermissions leer): das Modul ist immer
 * sichtbar, die einzelnen Sektionen hängen an den BESTEHENDEN Domänenrechten (sales.view,
 * finance.view, …). So braucht der Reporting-Hub keine neue Migration und erscheint sofort.
 */
export const auswertungModule: ForqModuleManifest = {
  id: 'auswertung',
  name: 'Auswertung',
  description: 'Modulübergreifende Kennzahlen: Vertrieb, Finanzen, Lager, Maschinen, Service und Mietpark an einem Ort',
  version: '0.1.0',
  route: '/auswertung',
  category: 'commercial',
  status: 'development',
  requiredPermissions: [],
  features: [
    'auswertung.overview',
    'auswertung.sales',
    'auswertung.finance',
    'auswertung.warehouse',
    'auswertung.machines',
    'auswertung.service',
    'auswertung.rental',
  ],
  navigation: [
    { id: 'auswertung.primary', label: 'Auswertung', route: '/auswertung', placement: 'primary', order: 20, icon: 'auswertung' },
    { id: 'auswertung.launcher', label: 'Auswertung', route: '/auswertung', placement: 'launcher', order: 20, icon: 'auswertung' },
  ],
};

/** Je Sektion ein Feature, gebunden an das bestehende Sichtrecht der jeweiligen Domäne. */
export const auswertungFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'auswertung.overview', moduleId: 'auswertung', name: 'Übersicht',
    description: 'Kennzahlen aller Bereiche auf einen Blick', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: [], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.sales', moduleId: 'auswertung', name: 'Vertrieb',
    description: 'Pipeline, Win-Rate, Umsatz nach Kanal/Quelle und Prognose', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.finance', moduleId: 'auswertung', name: 'Finanzen',
    description: 'Umsatz, Rohertrag, offene Posten und Fälligkeiten', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['finance.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.warehouse', moduleId: 'auswertung', name: 'Lager',
    description: 'Bestände, Unterdeckungen und Beschaffungsbedarf', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.machines', moduleId: 'auswertung', name: 'Maschinen',
    description: 'Bestand nach Status und Lagerwert', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.service', moduleId: 'auswertung', name: 'Service',
    description: 'Werkstattauslastung: Planung, Freigaben, Abrechnung', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'auswertung.rental', moduleId: 'auswertung', name: 'Mietpark',
    description: 'Aktive Vermietungen, Auslastung und laufender Mietumsatz', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['rental.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed'],
  },
];
